// Customer logo storage helpers (manual upload only — Clearbit auto-fetch was
// removed because their free tier no longer reliably returns logos for the
// kind of B2B brands we deal with).
import { supabase } from './supabase.js';

const BUCKET = 'customer-logos';

function fileExt(contentType) {
  if (!contentType) return 'png';
  if (contentType.includes('png'))  return 'png';
  if (contentType.includes('jpeg')) return 'jpg';
  if (contentType.includes('jpg'))  return 'jpg';
  if (contentType.includes('svg'))  return 'svg';
  if (contentType.includes('webp')) return 'webp';
  return 'png';
}

// Upload a blob to the customer-logos bucket and return the public URL.
// Path uses the customer id + a cache-busting timestamp so old versions don't
// stick around in CDN cache after re-upload.
export async function uploadCustomerLogo(customerId, blob, contentType) {
  const ext = fileExt(contentType);
  const path = `${customerId}/${Date.now()}.${ext}`;
  const { error } = await supabase.storage.from(BUCKET).upload(path, blob, {
    contentType: contentType || 'image/png',
    upsert: false,
    cacheControl: '604800',
  });
  if (error) throw error;
  const { data } = supabase.storage.from(BUCKET).getPublicUrl(path);
  return data.publicUrl;
}

// Best-effort cleanup of previous logos for a customer. Won't error.
export async function deleteOldCustomerLogos(customerId, exceptUrl) {
  try {
    const { data, error } = await supabase.storage.from(BUCKET).list(String(customerId));
    if (error || !data) return;
    const toRemove = data
      .map(f => `${customerId}/${f.name}`)
      .filter(p => !exceptUrl || !exceptUrl.endsWith(p));
    if (toRemove.length === 0) return;
    await supabase.storage.from(BUCKET).remove(toRemove);
  } catch { /* swallow */ }
}
